import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-bookings',
    templateUrl: './bookings.component.html',
    styleUrls: ['./bookings.component.scss'],
    standalone: false
})
export class BookingsComponent implements OnInit {
  sanitizedUrl: any;

  constructor(
    private sanitizer: DomSanitizer,
  ) { }

  ngOnInit(): void {
    let calendlyUrl = "https://calendly.com/michaes/software-automation"
    this.sanitizedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(calendlyUrl);
  }

}
